export const maxFollowingsCount = 1_000;
